export default function getApiUrl() {
  if (window.location.hostname === "localhost") {
    return "http://localhost:8080";
  } else {
    return process.env.REACT_APP_API_URL;
  }
}
